import Format from 'app/src/data/Format';
import RetailCollection from 'app/src/data/models/RetailCollection';
import Shop from 'app/src/data/models/Shop';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class ShopCollection extends RetailCollection {
  get model() {
    return Shop;
  }

  /**
   * Return the REST url for collection of Shop models
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/Shop.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.Shop is an array of the Shop structures we want.
    // Return it directly if an object is found; otherwise return an empty array and let
    // Backbone handle it
    let shops = response.Shop || [];

    // store the count if present
    this.recordCount = Format.parseInt((response['@attributes'] || {}).count, 0);

    return shops;
  }
}
